/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Error 520
 * @export
 * @interface PostCharactersCharacterIdContactsError520
 */
export interface PostCharactersCharacterIdContactsError520 {
    /**
     * Error 520 message
     * @type {string}
     * @memberof PostCharactersCharacterIdContactsError520
     */
    error?: string;
}

/**
 * Check if a given object implements the PostCharactersCharacterIdContactsError520 interface.
 */
export function instanceOfPostCharactersCharacterIdContactsError520(value: object): value is PostCharactersCharacterIdContactsError520 {
    return true;
}

export function PostCharactersCharacterIdContactsError520FromJSON(json: any): PostCharactersCharacterIdContactsError520 {
    return PostCharactersCharacterIdContactsError520FromJSONTyped(json, false);
}

export function PostCharactersCharacterIdContactsError520FromJSONTyped(json: any, ignoreDiscriminator: boolean): PostCharactersCharacterIdContactsError520 {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function PostCharactersCharacterIdContactsError520ToJSON(json: any): PostCharactersCharacterIdContactsError520 {
    return PostCharactersCharacterIdContactsError520ToJSONTyped(json, false);
}

export function PostCharactersCharacterIdContactsError520ToJSONTyped(value?: PostCharactersCharacterIdContactsError520 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

